/* eslint no-shadow: ["error", { "allow": ["state"] }]	*/
import Vue from 'vue';
import Vuex from 'vuex';

import { getForumTopics, createForumTopic, deleteForumTopic } from '../../utils/api/forum';
import { success, fail } from '../../utils/toast';
import router from '../../router';

Vue.use(Vuex);

const state = {
	forumTopics: [],
	loadingForumTopics: false,
	error: false,
	postStatus: '',
	forumStatus: '',
	total: 0,
	forumPost: {}
};

const getters = {
	fetchForumTopics: (state) => {
		return state.forumTopics;
	},
	getPostStatus: (state) => {
		return state.postStatus;
	},
	getForumStatus: (state) => {
		return state.forumStatus;
	},
	getTotalTopics: (state) => {
		return state.total;
	},
	getForumPost: (state) => {
		return state.forumPost;
	}
};

const mutations = {
	forumPostError: (state) => {
		state.postStatus = 'error';
	},
	forumPostRequest: (state) => {
		state.postStatus = 'loading';
	},
	forumPostSuccess: (state) => {
		state.postStatus = 'success';
	},
	saveForumTopics: (state, data) => {
		[state.forumTopics, state.total] = data;
		state.loadingForumTopics = false;
	},
	loadingForumTopics: (state) => {
		state.loadingForumTopics = true;
		state.error = false;
	},
 	forumTopicError: (state) => {
		state.forumStatus = 'error';
	},
	forumTopicSuccess: (state) => {
		state.forumStatus = 'success';
	},
	requestForumTopic: (state) => {
		state.forumStatus = 'loading';
	},
	addForumTopic: (state, data) => {
		state.forumTopics = [...state.forumTopics, data];
	},
	resetForumStatus: (state) => {
		state.forumStatus = '';
	},
	forumPostReset: (state) => {
		state.postStatus = '';
	},
	saveForumPost: (state, data) => {
		state.forumPost = data;
	},
	forumDeleteRequest: (state) => {
		state.forumStatus = 'loading';
	},
	forumDeleteSuccess: (state, data) => {
		state.forumTopics.filter((item) => {
			if (item.id === data.id) {
				state.forumToics = state.forumTopics.splice(state.forumTopics.indexOf(item), 1);
				return true;
			}
			return false;
		});
	}
};

const actions = {
	getForumTopics: ({ commit }, options) => {
		commit('resetForumStatus');
		const [limit, offset] = options;
		commit('requestForumTopic');
		getForumTopics(limit, offset)
			.then((response) => {
				if (response.status === 200) {
					commit('saveForumTopics', [response.data.data, response.data.total]);
					commit('forumTopicSuccess');
				}
			})
			.catch((error) => {
				fail({
					title: 'Oops! Error fetching Forum topics',
					text: error.data
				});
				commit('forumTopicError');
			});
		return true;
	},
	postForumTopic: ({ commit }, postData) => {
		commit('forumPostRequest');
		createForumTopic(postData)
			.then((response) => {
				if (response.status === 201) {
					commit('forumPostSuccess');
					success({
						title: 'Success! Forum post created.'
					});
					return true;
				}	
				return false;
			})
			.catch((error) => {
				commit('forumPostError');
				fail({
					title: 'Oops! Failed to create Post.',
					text: error.data
				});
				return error;
			})
			.finally(() => {
				commit('forumPostReset');
			});
	},
	deleteForumTopic: ({ commit }, forumData) => {
		commit('forumDeleteRequest');
		deleteForumTopic(forumData.id)
			.then((response) => {
				if (response.status === 200) {
					commit('forumDeleteSuccess', forumData);
					success({
						title: 'Success! Forum topic has been deleted.'
					});
					router.push('/forum');
					return true;
				}
				return false;
			}).catch((error) => {
				fail({
					title: 'Oops! Something went wrong',
					text: error.data
				});
				return false;
			});
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
